import {
  ColorProps,
  StyleProps,
  Text,
  TextProps,
  TypographyProps
} from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import sanitizeHtml from 'sanitize-html';
import { TextStyle } from '../../../../theme/common';
export { Text } from '@chakra-ui/react';
export type { TextProps } from '@chakra-ui/react';

type SizeType = 'xl' | 'lg' | 'md' | 'sm' | 'xs';
type ColorVariantType = 'accent' | 'lighter' | 'inherit';
type WeightType = 'bold' | 'semiBold' | 'normal';

export type ParagaphProps = PropsWithChildren<{
  size?: SizeType;
  colorVariant?: ColorVariantType;
  weight?: WeightType;
  isSpan?: boolean;
}> &
  TextProps;

export function Paragraph({
  children,
  size,
  weight,
  colorVariant,
  isSpan,
  ...rest
}: ParagaphProps): JSX.Element {
  const style = getParagrapheStyle({ size, colorVariant, weight });
  if (typeof children === 'string') {
    return (
      <Text
        as={isSpan ? 'span' : undefined}
        {...style}
        {...rest}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(children, { allowedTags: ['a', 'b', 'br'] })
        }}
      />
    );
  }

  return (
    <Text as={isSpan ? 'span' : undefined} {...style} {...rest}>
      {children}
    </Text>
  );
}

function getParagrapheStyle({
  size = 'md',
  colorVariant = 'inherit',
  weight
}: {
  size?: SizeType;
  colorVariant?: ColorVariantType;
  weight?: WeightType;
}): StyleProps {
  const variantHandler: { [key in SizeType]: { textStyle: TextStyle } } = {
    xl: { textStyle: 'bodyExtraExtraLarge' },
    lg: { textStyle: 'bodyExtraLarge' },
    md: { textStyle: 'bodyLarge' },
    sm: { textStyle: 'bodyMedium' },
    xs: { textStyle: 'bodySmall' }
  };
  const colorHandler: { [key in ColorVariantType]: ColorProps } = {
    accent: { color: 'palette_blue.100' },
    lighter: { color: 'palette_gray.60' },
    inherit: { color: 'inherit' }
  };

  const weightHandler: { [key in WeightType]: TypographyProps } = {
    bold: { fontWeight: 700 },
    semiBold: { fontWeight: 600 },
    normal: { fontWeight: 400 }
  };
  return {
    ...variantHandler[size],
    ...colorHandler[colorVariant],
    ...(weight && weightHandler[weight])
  };
}
